module.exports = __webpack_public_path__ + "lab-54149b988ae830d0f866d0a28eb6490d.svg";